<template>
    <form :class="`flex flex:col ai:stretch jc:center gap:${gap}`" :id="id">
        <slot></slot>
    </form>
</template>

<script setup>
    const props = defineProps({
        gap: { default: 32, type: Number },
        id: { default: () => nextId(), type: String }
    });

    const emit = defineEmits(["submit"]);

    const init = (fields) => {
        const validator = new JustValidate(`#${props.id}`, {
            errorLabelCssClass: ["font-xs", "mt:6", "f:r500!"],
            errorFieldCssClass: ["invalidField"]
        });

        fields.forEach((field) => field.value.apply(validator));

        validator.onSuccess(() => emit("submit"));

        return validator;
    };

    defineExpose({ init });
</script>
